import React from 'react';
import { Card } from './ui/card';

const CelebrityCases = () => {
  const celebrities = [
    {
      name: 'Chow Yuen Fatt',
      description: 'Hong Kong actor and filmmaker. Career spanning 45+ years',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/isvgkgf7_Red%20and%20Gold%20Illustrative%20Merry%20Christmas%20Document.png'
    },
    {
      name: 'Donald Trump',
      description: 'Politician, media personality, and businessman',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/8u7hqrdy_4.png'
    },
    {
      name: 'Louis Koo',
      description: 'Hong Kong award-winning actor, singer, entrepreneur',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/grfql0mx_5.png'
    },
    {
      name: 'Novak Djokovic',
      description: 'Best tennis player in history',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/2cls3adx_3%20copy%202.png'
    },
    {
      name: 'Stephen Chow',
      description: 'Hong Kong filmmaker and former actor',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/xh6h6rgf_7.png'
    },
    {
      name: 'Beyoncé',
      description: 'American singer, songwriter, and businesswoman',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/1e3lhl9m_6.png'
    }
  ];

  const characteristics = [
    'Contain certain symbols that symbolise vitality, wisdom and luck energies',
    'Strong, bold strokes: Reflect confidence and authority',
    'Upward-slanting signature: Symbolizes progress and continuous growth',
    'Clear, legible writing: Shows clarity in thoughts and purpose',
    'Long finishing strokes: Indicate perseverance and ability to follow through'
  ];

  return (
    <div className="py-24 bg-[#0A0A0B] text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-[#F5A623] text-sm font-semibold tracking-wider uppercase mb-4">
            Case Studies
          </p>
          <h2 className="text-5xl font-bold mb-6">
            Wealth <span className="italic text-[#F5A623]">Feng Shui</span> Signatures
          </h2>
          
          <div className="max-w-4xl mx-auto mb-8">
            <p className="text-xl text-gray-300 leading-relaxed mb-6">
              Successful Sportsman, Politician and Celebrities are having their signature being redesign and that is their secret weapon. Your signature is a personal energy imprint. It appears on your contracts, business deals, financial documents, and personal correspondences. If it carries weak energy, it could be blocking your financial flow and career growth without you even realizing it!
            </p>
            <p className="text-xl text-gray-300 leading-relaxed">
              But here's the good news: Your signature is within your control—and with the right strokes, adjustments, and alignment, you can activate new opportunities, financial breakthroughs, and a path to success!
            </p>
          </div>
        </div>

        {/* Celebrity Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {celebrities.map((celebrity, index) => (
            <Card 
              key={index}
              className="bg-[#1A1A1D] border-white/10 overflow-hidden group hover:border-[#F5A623]/50 transition-all duration-300"
            >
              <div className="relative">
                <img 
                  src={celebrity.image}
                  alt={celebrity.name}
                  className="w-full h-auto object-contain"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent flex flex-col justify-end p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">{celebrity.name}</h3>
                  <p className="text-sm text-gray-300">{celebrity.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Characteristics */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#1A1A1D] border border-white/10 rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-6 text-[#F5A623]">What Makes a Wealth Signature Powerful:</h3>
            <ul className="space-y-4">
              {characteristics.map((characteristic, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-[#F5A623] text-xl mr-4 mt-1">✓</span>
                  <p className="text-lg text-gray-300">{characteristic}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CelebrityCases;